import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Text, Badge } from '@plurall/elo-beta'

import ResendEmailResponsible from '../ResendEmailResponsible'

import styles from './TableCustomResponsibles.module.scss'

const TableCustomResponsibles = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectResponsible, setSelectResponsible] = useState(null)

  const closeAlert = () => {
    setIsOpen(false)
  }
  const openAlert = parent => {
    setSelectResponsible(parent)
    setIsOpen(true)
  }

  return (
    <div className={styles.container}>
      <table>
        <thead>
          <tr>
            <th>
              <Text bold size={'t4'} dimmed className={styles['th-name']}>
                RESPONSÁVEL
              </Text>
            </th>
            <th>
              <Text bold size={'t4'} dimmed>
                E-MAIL
              </Text>
            </th>
            <th>
              <Text bold size={'t4'} dimmed>
                STATUS
              </Text>
            </th>
            <th>
              <Text bold size={'t4'} dimmed>
                AÇÕES
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.person?.parents.map(parent => {
            return (
              <tr>
                <td>
                  <Text size={'t3'} dimmed>
                    {parent.name}
                  </Text>
                </td>
                <td>
                  <Text size={'t3'} dimmed>
                    {parent.email}
                  </Text>
                </td>
                <td>
                  <Badge variant={!parent.isConfirmedRelation ? 'attention' : 'positive'}>
                    {!parent.isConfirmedRelation ? 'Aguardando aprovação' : 'Vinculado'}
                  </Badge>
                </td>
                {!parent.isConfirmedRelation && (
                  <td>
                    <Text size={'t3'} element={'a'} onClick={() => openAlert(parent)}>
                      Reenviar e-mail
                    </Text>
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
      {isOpen && (
        <ResendEmailResponsible
          closeAlert={closeAlert}
          selectResponsible={selectResponsible}
          idPerson={data?.person.id}
        />
      )}
    </div>
  )
}

TableCustomResponsibles.propTypes = {
  data: PropTypes.shape({
    person: PropTypes.object,
  }),
}

export default TableCustomResponsibles
